import { useEffect } from 'react';

/**
 * Escape dismisses whatever is on top. The listener is on the document rather
 * than the dialog because a modal that has not been focused yet still has to
 * answer the key.
 */
export const useEscapeKey = (onEscape: () => void): void => {
  useEffect(() => {
    const onKeyDown = (event: KeyboardEvent): void => {
      if (event.key === 'Escape') {
        onEscape();
      }
    };

    document.addEventListener('keydown', onKeyDown);
    return (): void => {
      document.removeEventListener('keydown', onKeyDown);
    };
  }, [onEscape]);
};
